<template>
	<v-layout
		wrap align-center
		class="section-about"
		id="about" background
	>
		<v-flex xs12 class="container">
			<v-layout wrap align-center>
				<v-flex class="section-about-container">
					<!-- <h2 class="section-about-title secondary--text">SE PARTE DE NUESTRA COMUNIDAD</h2>
					<h2 class="section-about-title section-about-title-app info-black--text">Y APOYA AL NEGOCIO LOCAL</h2> -->
					<h2 class="section-about-title secondary--text">SOMOS LA SOLUCIÓN MÓVIL</h2>
					<h2 class="section-about-title section-about-title-app info-black--text">PARA TU NEGOCIO</h2>
					<p class="section-about-text info--text">
						Casa Market nace de la coyuntura actual, con el 
						propósito de impactar positivamente en la comunidad de emprendedores.
					</p>
					<div row wrap class="section-about-card layout wrap justify-center">
						<v-flex :key="card.id" v-for="card in cards" md4>
							<card-icon :card="card"></card-icon>
						</v-flex>
					</div>
				</v-flex>
				<v-flex class="section-about-right">
					<img
						src="/static/images/sections/section-1-CM.png"
						alt="app mi bodega"
						class="section-about-image"
					/>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	import cardIcon from '@/components/shared/card-icon';

	function data() {
		return {
			cards: [
				{
					id: 1,
					alt: 'aumentar ventas, fidelizar clientes, evitar contagios',
					icon: '/static/images/icons/icon-1-CM.svg',
					text: 'Ayudamos a incrementar tus ventas y fidelizar a tus clientes.',
				},
				{
					id: 2,
					alt: 'tu propia marca y logo',
					icon: '/static/images/icons/icon-2-CM.svg',
					text: 'App 100% personalizada a tu negocio: con tu marca y logo.',
				},
				{
					id: 3,
					alt: 'sencillo de usar',
					icon: '/static/images/icons/icon-3-CM.svg',
					text: 'Muy sencillo de usar para ti y tus clientes de siempre.',
				},
				{
					id: 4,
					alt: 'Somos una comunidad de comercios locales',
					icon: '/static/images/icons/icon-4-CM.svg',
					text: 'Somos una comunidad de comercios locales.',
				},
				{
					id: 5,
					alt: 'Promovemos el distanciamiento social.',
					icon: '/static/images/icons/icon-4-CM.svg',
					text: 'Promovemos el distanciamiento social.',
				},
			],
		};
	}

	export default {
		name: 'section-about',
		components: {
			cardIcon,
		},
		data,
	};
</script>

<style lang="scss" scoped>
	.section-about {
		margin-top: -22px;
		padding: 60px 27px 72px;

		@media (min-width: 1024px) {
			padding: 90px 0px;
		}

		&-image {
			height: auto;
			max-width: 100%;

			@media (min-width: 768px) {
				height: 300px;
			}

			@media (min-width: 1280px) {
				height: 310px;
			}

			@media (min-width: 1340px) {
				height: 371px;
			}
		}

		&-right {
			margin-top: 31px;
			text-align: center;
			width: 100%;

			@media (min-width: 1280px) {
				margin-top: 0px;
				padding-left: 1%;
				text-align: left;
				max-width: 47%;
			}
		}

		&-container {
			text-align: center;
			width: 100%;

			@media (min-width: 1280px) {
				max-width: 53%;
				text-align: left;
			}
		}

		&-title {
			font-size: size(large38);
			font-weight: weight(w900);
			line-height: 1;

			@media (min-width: 1024px) {
				font-size: size(large30);
			}

			&-app {
				@media (min-width: 1024px) {
					font-size: size(large38);
				}	
			}
		}

		&-text {
			font-size: size(medium16);
			line-height: 28px;
			margin-bottom: 40px;
			margin-top: 33px;

			@media (min-width: 1024px) {
				line-height: 25px;
				margin: 25px auto 40px;
				max-width: 70%;
			}

			@media (min-width: 1280px) {
				max-width: 65%;
				margin: 25px 0px 40px;
			}
		}

		&-card {
			@media (min-width: 1024px) {
				margin: auto;
				max-width: 70%;
			}

			@media (min-width: 1280px) {
				margin: auto;
				max-width: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-about.vue